import { useEffect, useMemo, useState } from "react";

import { pageCount } from "./pager.utils";

/**
 * Pages a list that is already fully loaded in the browser (e.g. report
 * tables). Goes back to page 1 when the number of rows changes (new filters).
 * Spread the result (minus pageRows) into <ListPager />.
 */
export const usePagedRows = <T>(rows: T[], pageSize = 50) => {
  const [page, setPage] = useState(1);
  const total = rows.length;
  useEffect(() => setPage(1), [total]);
  const current = Math.min(page, pageCount(total, pageSize));
  const pageRows = useMemo(
    () => rows.slice((current - 1) * pageSize, current * pageSize),
    [rows, current, pageSize],
  );
  return {
    pageRows,
    pager: { page: current, onChange: setPage, pageSize, total },
  };
};
